import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const BOAT = {
  nickname: 'PRODUCTS.BOAT.nickname',
  subtipeDefaultValue: 'MotorBoat',
  subtipeProperties: {
    Sailboat: [
      { name: 'wtcBoatGroup', key: 'WTC_BOAT_GROUP', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_GROUP.SAILBOAT', value: 'Sailboat' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_GROUP.MOTORBOAT', value: 'MotorBoat' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_GROUP.NOMOTORBOAT', value: 'NoMotorBoat' }
          ]
        }
      },
      { name: 'wtcMembership', key: 'SAILBOAT_MEMBERSHIP', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.SAILBOAT_MEMBERSHIP.NORGE_SEIL_GROUP', value: 'Norges Seilforbund' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.SAILBOAT_MEMBERSHIP.ALL_OTHER_VALUES', value: 'All other values' }
          ]
        }
      },
      {
        name: 'wtcBoatMark', key: 'WTC_BOAT_MARK', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.STRING,
        validator: ['', [
          Validators.required
        ]],
      },
      {
        name: 'wtcBoatModel', key: 'WTC_BOAT_MODEL', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.STRING,
        validator: ['', [
          Validators.required
        ]],
      },
      { name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO',
        BOAT: true,
        inputType: INPUT_TYPES_CONFIG.STRING,
        validator: ['', [
          Validators.pattern(/[a-zA-Z]{3}\d{3}/)
        ]]
      },
      { name: 'calculationShipFeet', key: 'CALCULATION_SHIP_FEET', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.NUMBER,
        validator: ['', [
          Validators.required
        ]]
      },
      { name: 'calculationShipArea', key: 'CALCULATION_SHIP_AREA', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.NUMBER,
        validator: ['', [
          Validators.required
        ]]
      },
      { name: 'boatBuiltYear', key: 'BUILD_YEAR', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.DATE,
        validator: ['', [
        Validators.required
        ]],
        settings: {
          dateView: 'multi-years'
        }
      },
      { name: 'wtcBoatValue', key: 'WTC_BOAT_VALUE', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.NUMBER,
        validator: ['', [
          Validators.required
        ]]
      },
      { name: 'wtcBoatHasMotor', key: 'BOAT_HAS_MOTOR', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.BOOLEAN,
        isBoatHasMotorCheck: true,
        validator: ['', [
          Validators.required
        ]]
      },
      {
        name: 'wtcBoatMotorMark', key: 'BOAT_MOTOR_MARK', group: 'OBJECT_INFO',
      },
      {
        name: 'wtcBoatTotalNk', key: 'BOAT_TOTAL_NK', group: 'OBJECT_INFO',
      },
      { name: 'wtcBoatDamage', key: 'BOAT_DAMAGE', group: 'INSURANCE_INFO' },
      {
        name: 'wtcBoatMotorAge', key: 'BOAT_MOTOR_AGE', group: 'OBJECT_INFO',
      },
      {
        name: 'wtcBoatExtraValuables', key: 'WTC_EXTRA_VALUABLES', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.0', value: '0' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.10', value: '10000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.20', value: '20000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.30', value: '30000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.40', value: '40000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.50', value: '50000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.75', value: '75000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.100', value: '100000' }
          ]
        }
      },
      {
        name: 'wtcBoatCinCode', key: 'BOAT_CIN_CODE', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.STRING,
        validator: ['']
      },
      {
        name: 'wtcBoatTracker', key: 'WTC_TRACKER', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.BOOLEAN,
        validator: ['', [
          Validators.required
        ]]
      },
      {
        name: 'wtcBoatSecuremark', key: 'WTC_BOAT_SECUREMARK', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.BOOLEAN,
        isBoatSecuremarkCheck: true,
        validator: ['', [
          Validators.required
        ]]
      },
      {
        name: 'wtcBoatSecuremarkNumber', key: 'BOAT_SECUREMARK_NUMBER', group: 'OBJECT_INFO'
      },
      {
        name: 'wtcBoatHarborSecurity', key: 'HARBOR_PERMANENT_SECURITY', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.BOOLEAN,
        validator: ['', [
          Validators.required
        ]]
      },
      { name: 'wtcBoatpostcode', key: 'OBJECT_ZIP_WTC_BOAT', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.TEL,
        validator: ['', [
          Validators.required,
          Validators.pattern('[0-9]{4}$')
        ]],
        customProductTypeConfig: {
          BOAT: {
            key: 'OBJECT_ZIP_BOAT'
          }
        }
      },
      {
        name: 'wtcBoatWinterStorage', key: 'BOAT_WINTER_STORAGE_WTC', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_WINTER_STORAGE.AVLAST_BYGNING', value: 'avlast_bygning' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_WINTER_STORAGE.OUTDOORS_ON_LAND', value: 'outdoors_on_land' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_WINTER_STORAGE.BABLEHAVN', value: 'boblehavn' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_WINTER_STORAGE.ON_THE_SEA', value: 'on_the_sea' }
          ]
        }
      },
      {
        name: 'wtcBoatArea', key: 'BOAT_TRAFFIC_AREA', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_AREA.NO', value: 'Nei' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_AREA.EUROPA', value: 'Europa' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_AREA.VERDEN', value: 'Verden' }
          ]
        }
      },
      {
        name: 'wtcBoatRental', key: 'BOAT_RENTAL_WTC', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.BOOLEAN,
        validator: ['', [
          Validators.required
        ]]
      },
      { name: 'boatCompetition', key: 'BOAT_COMPETITION', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.BOOLEAN,
        validator: ['', [
          Validators.required
        ]]
      },
      { name: 'nauticalCompetence', key: 'NAUTICAL_COMPETENCE', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_NAUTICAL_COMPETENCE.NO', value: 'NO' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_NAUTICAL_COMPETENCE.BOAT_DRIVER_LICENSE', value: 'BOAT_DRIVER_LICENSE' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_NAUTICAL_COMPETENCE.COAST_GUARD_CERTIFICATE', value: 'COAST_GUARD_CERTIFICATE' }
          ]
        }
      },
      {
        name: 'wtcBoatYoungUser', key: 'WTC_BOAT_YOUNG_USER', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.BOOLEAN,
        validator: ['', [
          Validators.required
        ]]
      },
      {
        name: 'wtcBoatExcess', key: 'WTC_BOAT_EXPRESS', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.5', value: '5000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.75', value: '7500' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.10', value: '10000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.15', value: '15000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.20', value: '20000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.25', value: '25000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.30', value: '30000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.50', value: '50000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.100', value: '100000' },
          ]
        }
      },
      { name: 'productPackage', key: 'PRODUCT_PACKAGE_WTC', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        isWtcBoatBoatDamageCheck: true,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ANSVAR', value: 'ANSVAR' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.BRANN_TYVERI', value: 'BRANN_OG_TYVERI' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO', value: 'KASKO' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ELITE', value: 'SUPER' },
          ]
        }
      },
      // { name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO'},
      // { name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO' },
      // {
      //   name: 'wtcBoatFeet', key: 'WTC_BOAT_FEET', group: 'OBJECT_INFO',
      //   inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      //   validator: ['', [
      //     Validators.required
      //   ]],
      //   settings: {
      //     list: [
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.8', value: '8' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.9', value: '9' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.10', value: '10' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.11', value: '11' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.12', value: '12' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.13', value: '13' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.14', value: '14' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.15', value: '15' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.16', value: '16' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.17', value: '17' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.18', value: '18' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.19', value: '19' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.20', value: '20' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.21', value: '21' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.22', value: '22' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.23', value: '23' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.24', value: '24' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.25', value: '25' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.26', value: '26' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.27', value: '27' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.28', value: '28' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.29', value: '29' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.30', value: '30' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.31', value: '31' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.32', value: '32' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.33', value: '33' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.34', value: '34' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.35', value: '35' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.36', value: '36' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.37', value: '37' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.38', value: '38' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.39', value: '39' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.40', value: '40' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.41', value: '41' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.42', value: '42' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.43', value: '43' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.44', value: '44' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.45', value: '45' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.46', value: '46' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.47', value: '47' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.48', value: '48' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.49', value: '49' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.50', value: '50' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.51', value: '51' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.52', value: '52' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.53', value: '53' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.54', value: '54' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.55', value: '55' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.56', value: '56' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.57', value: '57' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.58', value: '58' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.59', value: '59' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.60', value: '60' },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.61', value: '61' }
      //     ]
      //   }
      // },
      // { name: 'wtcBoatCoverage', key: 'BOAT_COVERAGE', group: 'OBJECT_INFO',
      //   inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      //   validator: ['', [
      //     Validators.required
      //   ]]
      // },
    ],
    MotorBoat: [
      { name: 'wtcBoatGroup', key: 'WTC_BOAT_GROUP', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_GROUP.SAILBOAT', value: 'Sailboat' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_GROUP.MOTORBOAT', value: 'MotorBoat' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_GROUP.NOMOTORBOAT', value: 'NoMotorBoat' }
          ]
        }
      },
      {
        name: 'wtcBoatMark', key: 'WTC_BOAT_MARK', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.STRING,
        validator: ['', [
          Validators.required
        ]],
      },
      {
        name: 'wtcBoatModel', key: 'WTC_BOAT_MODEL', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.STRING,
        validator: ['', [
          Validators.required
        ]],
      },
      {
        name: 'wtcMotorBoatType', key: 'WTC_BOAT_MOTOR_TYPE', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        selectWidth: 'medium',
        validator: ['', [
          Validators.required
        ]],
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_MOTOR_TYPE.OUTBOARD_ENGINE', value: 'outboard_engine' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_MOTOR_TYPE.CABIN_CRUISER', value: 'cabin_cruiser' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_MOTOR_TYPE.DAY_CRUISER', value: 'daycruiser' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_MOTOR_TYPE.UP_TO_16_FEET', value: 'up_to_16_feet' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_MOTOR_TYPE.RIB', value: 'RIB' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_MOTOR_TYPE.CENTER_CONSOLE', value: 'center_console' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_MOTOR_TYPE.DOUBLE_ENDER', value: 'double_ender' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_MOTOR_TYPE.PERSONAL_WATERCRAFT', value: 'personal_watercraft' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_MOTOR_TYPE.BOWRIDER', value: 'bowrider' }
          ]
        }
      },
      {
        name: 'wtcBoatFeet', key: 'WTC_BOAT_FEET', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.8', value: '8' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.9', value: '9' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.10', value: '10' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.11', value: '11' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.12', value: '12' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.13', value: '13' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.14', value: '14' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.15', value: '15' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.16', value: '16' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.17', value: '17' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.18', value: '18' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.19', value: '19' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.20', value: '20' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.21', value: '21' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.22', value: '22' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.23', value: '23' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.24', value: '24' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.25', value: '25' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.26', value: '26' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.27', value: '27' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.28', value: '28' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.29', value: '29' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.30', value: '30' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.31', value: '31' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.32', value: '32' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.33', value: '33' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.34', value: '34' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.35', value: '35' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.36', value: '36' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.37', value: '37' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.38', value: '38' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.39', value: '39' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.40', value: '40' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.41', value: '41' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.42', value: '42' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.43', value: '43' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.44', value: '44' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.45', value: '45' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.46', value: '46' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.47', value: '47' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.48', value: '48' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.49', value: '49' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.50', value: '50' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.51', value: '51' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.52', value: '52' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.53', value: '53' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.54', value: '54' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.55', value: '55' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.56', value: '56' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.57', value: '57' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.58', value: '58' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.59', value: '59' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.60', value: '60' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.61', value: '61' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.62', value: '62' }
          ]
        }
      },
      { name: 'boatBuiltYear', key: 'BUILD_YEAR_BOAT', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.DATE,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          dateView: 'multi-years'
        }
      },
      {
        name: 'wtcBoatMotorsCount', key: 'BOAT_MOTORS_COUNT', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.NUMBER,
        validator: ['', [
          Validators.required
        ]]
      },
      {
        name: 'wtcBoatMotorMark', key: 'BOAT_MOTOR_MARK', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.STRING,
        validator: ['', [
          Validators.required
        ]]
      },
      {
        name: 'wtcBoatTotalNk', key: 'BOAT_TOTAL_NK', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.NUMBER,
        validator: ['', [
          Validators.required
        ]]
      },
      {
        name: 'wtcBoatMotorAge', key: 'BOAT_MOTOR_AGE', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.DATE,
        isWtcBoatMotorInsuranceCheck: true,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          dateView: 'multi-years'
        }
      },
      { name: 'boatMaxSpeed', key: 'BOAT_MAX_SPEED_WTC', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_0', value: '0', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_1', value: '1', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_2', value: '2', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_3', value: '3', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_4', value: '4', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_5', value: '5', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_6', value: '6', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_7', value: '7', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_8', value: '8', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_9', value: '9', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_10', value: '10', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_11', value: '11', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_12', value: '12', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_13', value: '13', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_14', value: '14', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_15', value: '15', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_16', value: '16', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_17', value: '17', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_18', value: '18', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_19', value: '19', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_20', value: '20', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_21', value: '21', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_22', value: '22', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_23', value: '23', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_24', value: '24', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_25', value: '25', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_26', value: '26', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_27', value: '27', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_28', value: '28', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_29', value: '29', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_30', value: '30', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_31', value: '31', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_32', value: '32', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_33', value: '33', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_34', value: '34', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_35', value: '35', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_36', value: '36', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_37', value: '37', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_38', value: '38', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_39', value: '39', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_40', value: '40', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_41', value: '41', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_42', value: '42', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_43', value: '43', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_44', value: '44', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_45', value: '45', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_46', value: '46', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_47', value: '47', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_48', value: '48', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_49', value: '49', showBoatHightSpeedCertificate: false },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_50', value: '50', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_51', value: '51', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_52', value: '52', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_53', value: '53', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_54', value: '54', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_55', value: '55', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_56', value: '56', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_57', value: '57', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_58', value: '58', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_59', value: '59', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_60', value: '60', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_61', value: '61', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_62', value: '62', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_63', value: '63', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_64', value: '64', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_65', value: '65', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_66', value: '66', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_67', value: '67', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_68', value: '68', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_69', value: '69', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_70', value: '70', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_71', value: '71', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_72', value: '72', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_73', value: '73', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_74', value: '74', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_75', value: '75', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_76', value: '76', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_77', value: '77', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_78', value: '78', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_79', value: '79', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_80', value: '80', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_81', value: '81', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_82', value: '82', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_83', value: '83', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_84', value: '84', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_85', value: '85', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_86', value: '86', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_87', value: '87', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_88', value: '88', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_89', value: '89', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_90', value: '90', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_91', value: '91', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_92', value: '92', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_93', value: '93', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_94', value: '94', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_95', value: '95', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_96', value: '96', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_97', value: '97', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_98', value: '98', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_99', value: '99', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_100', value: '100', showBoatHightSpeedCertificate: true },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_MAX_SPEED.WTC_101', value: '101', showBoatHightSpeedCertificate: true }
          ]
        }
      },
      { name: 'wtcBoatValue', key: 'WTC_BOAT_VALUE', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.NUMBER,
        validator: ['', [
          Validators.required
        ]]
      },
      {
        name: 'wtcBoatExtraValuables', key: 'WTC_EXTRA_VALUABLES', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.0', value: '0' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.10', value: '10000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.20', value: '20000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.30', value: '30000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.40', value: '40000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.50', value: '50000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.75', value: '75000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.100', value: '100000' }
          ]
        }
      },
      { name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO',
        BOAT: true,
        inputType: INPUT_TYPES_CONFIG.STRING,
        validator: ['', [
          Validators.pattern(/[a-zA-Z]{3}\d{3}/)
        ]]
      },
      {
        name: 'wtcBoatCinCode', key: 'BOAT_CIN_CODE', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.STRING,
        validator: ['']
      },
      {
        name: 'wtcBoatTracker', key: 'WTC_TRACKER', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.BOOLEAN,
        validator: ['', [
          Validators.required
        ]]
      },
      {
        name: 'wtcBoatSecuremark', key: 'WTC_BOAT_SECUREMARK', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.BOOLEAN,
        isBoatSecuremarkCheck: true,
        validator: ['', [
          Validators.required
        ]]
      },
      {
        name: 'wtcBoatSecuremarkNumber', key: 'BOAT_SECUREMARK_NUMBER', group: 'OBJECT_INFO'
      },
      {
        name: 'wtcBoatHarborSecurity', key: 'HARBOR_PERMANENT_SECURITY', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.BOOLEAN,
        validator: ['', [
          Validators.required
        ]]
      },
      { name: 'wtcBoatpostcode', key: 'OBJECT_ZIP_WTC_BOAT', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.TEL,
        validator: ['', [
          Validators.required,
          Validators.pattern('[0-9]{4}$')
        ]],
        customProductTypeConfig: {
          BOAT: {
            key: 'OBJECT_ZIP_BOAT'
          }
        }
      },
      {
        name: 'wtcBoatWinterStorage', key: 'BOAT_WINTER_STORAGE_WTC', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_WINTER_STORAGE.AVLAST_BYGNING', value: 'avlast_bygning' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_WINTER_STORAGE.OUTDOORS_ON_LAND', value: 'outdoors_on_land' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_WINTER_STORAGE.BABLEHAVN', value: 'boblehavn' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_WINTER_STORAGE.ON_THE_SEA', value: 'on_the_sea' }
          ]
        }
      },
      {
        name: 'wtcBoatArea', key: 'BOAT_TRAFFIC_AREA', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_AREA.NO', value: 'Nei' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_AREA.EUROPA', value: 'Europa' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_AREA.VERDEN', value: 'Verden' }
          ]
        }
      },
      { name: 'boatCompetition', key: 'BOAT_COMPETITION', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.BOOLEAN,
        validator: ['', [
          Validators.required
        ]]
      },
      { name: 'nauticalCompetence', key: 'NAUTICAL_COMPETENCE', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_NAUTICAL_COMPETENCE.NO', value: 'NO' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_NAUTICAL_COMPETENCE.BOAT_DRIVER_LICENSE', value: 'BOAT_DRIVER_LICENSE' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_NAUTICAL_COMPETENCE.COAST_GUARD_CERTIFICATE', value: 'COAST_GUARD_CERTIFICATE' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.BOAT_NAUTICAL_COMPETENCE.HIGHT_SPEED_CERTIFICATE', value: 'HIGHT_SPEED_CERTIFICATE' }
          ]
        }
      },
      {
        name: 'wtcBoatHighSpeedCertificate', key: 'BOAT_HIGHT_SPEED_CERTIFICATE', group: 'INSURANCE_INFO'
      },
      {
        name: 'wtcBoatRental', key: 'BOAT_RENTAL_WTC', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.BOOLEAN,
        validator: ['', [
          Validators.required
        ]]
      },
      {
        name: 'wtcBoatYoungUser', key: 'WTC_BOAT_YOUNG_USER', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.BOOLEAN,
        validator: ['', [
          Validators.required
        ]]
      },
      {
        name: 'wtcBoatExcess', key: 'WTC_BOAT_EXPRESS', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.5', value: '5000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.75', value: '7500' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.10', value: '10000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.15', value: '15000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.20', value: '20000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.25', value: '25000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.30', value: '30000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.50', value: '50000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.100', value: '100000' },
          ]
        }
      },
      { name: 'productPackage', key: 'PRODUCT_PACKAGE_WTC', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        validator: ['', [
          Validators.required
        ]],
        isWtcBoatMotorInsuranceCheck: true,
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ANSVAR', value: 'ANSVAR' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.BRANN_TYVERI', value: 'BRANN_OG_TYVERI' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO', value: 'KASKO' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ELITE', value: 'SUPER' },
          ]
        }
      },
      {
        name: 'wtcBoatMotorInsurance', key: 'BOAT_MOTOR_INCURANCE', group: 'INSURANCE_INFO',
      },
      { name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO'},
      // { name: 'wtcBoatCoverage', key: 'BOAT_COVERAGE', group: 'OBJECT_INFO',
      //   inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      //   validator: ['', [
      //     Validators.required
      //   ]]
      // },
      // { name: 'wtcBoatNumberOfRenewals', key: 'NUMBER_OF_RENEWALS', group: 'OBJECT_INFO',
      //   inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      //   validator: ['', [
      //     Validators.required
      //   ]],
      //   settings: {
      //     list: [
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_NUMBER_OF_RENEWALS.0', value: 0 },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_NUMBER_OF_RENEWALS.1', value: 1 },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_NUMBER_OF_RENEWALS.2', value: 2 },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_NUMBER_OF_RENEWALS.3', value: 3 },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_NUMBER_OF_RENEWALS.4', value: 4 },
      //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_NUMBER_OF_RENEWALS.5', value: 5 }
      //     ]
      //   }
      // },
    ],
    NoMotorBoat: [
      { name: 'wtcBoatGroup', key: 'WTC_BOAT_GROUP', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_GROUP.SAILBOAT', value: 'Sailboat' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_GROUP.MOTORBOAT', value: 'MotorBoat' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_GROUP.NOMOTORBOAT', value: 'NoMotorBoat' }
          ]
        }
      },
      { name: 'productPackage', key: 'PRODUCT_PACKAGE_WTC', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ANSVAR', value: 'ANSVAR' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.BRANN_TYVERI', value: 'BRANN_OG_TYVERI' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO', value: 'KASKO' }
          ]
        }
      },
      {
        name: 'wtcBoatMark', key: 'WTC_BOAT_MARK', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.STRING,
        validator: ['', [
          Validators.required
        ]],
      },
      {
        name: 'wtcBoatModel', key: 'WTC_BOAT_MODEL', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.STRING,
        validator: ['', [
          Validators.required
        ]],
      },
      { name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO',
        BOAT: true,
        inputType: INPUT_TYPES_CONFIG.STRING,
        validator: ['', [
          Validators.pattern(/[a-zA-Z]{3}\d{3}/)
        ]]
      },
      {
        name: 'wtcMotorBoatType', key: 'WTC_BOAT_MOTOR_TYPE', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_MOTOR_TYPE_NO_MOTOR_BOAT.ROWING_BOAT', value: 'Robåt' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_MOTOR_TYPE_NO_MOTOR_BOAT.KAYAK', value: 'Kajakk' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_MOTOR_TYPE_NO_MOTOR_BOAT.CANOE', value: 'Kano' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_MOTOR_TYPE_NO_MOTOR_BOAT.SAILING_BOARD', value: 'Seilbrett' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_MOTOR_TYPE_NO_MOTOR_BOAT.WIND_BOAT', value: 'Seiljolle' }
          ]
        }
      },
      { name: 'boatBuiltYear', key: 'BUILD_YEAR', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.DATE,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          dateView: 'multi-years'
        }
      },
      {
        name: 'wtcBoatExcess', key: 'WTC_BOAT_EXPRESS', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.2', value: '2500' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.5', value: '5000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.75', value: '7500' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.10', value: '10000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.15', value: '15000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.20', value: '20000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.25', value: '25000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.30', value: '30000' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_EXPRESS.50', value: '50000' },
          ]
        }
      },
      {
        name: 'wtcBoatFeet', key: 'WTC_BOAT_FEET', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        validator: ['', [
          Validators.required
        ]],
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.8', value: '8' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.9', value: '9' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.10', value: '10' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.11', value: '11' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.12', value: '12' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.13', value: '13' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.14', value: '14' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.15', value: '15' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.16', value: '16' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.17', value: '17' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.18', value: '18' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.19', value: '19' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.20', value: '20' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.21', value: '21' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.22', value: '22' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.23', value: '23' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.24', value: '24' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.25', value: '25' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.26', value: '26' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.27', value: '27' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.28', value: '28' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.29', value: '29' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.30', value: '30' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.31', value: '31' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.32', value: '32' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.33', value: '33' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.34', value: '34' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.35', value: '35' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.36', value: '36' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.37', value: '37' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.38', value: '38' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.39', value: '39' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.40', value: '40' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.41', value: '41' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.42', value: '42' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.43', value: '43' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.44', value: '44' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.45', value: '45' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.46', value: '46' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.47', value: '47' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.48', value: '48' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.49', value: '49' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.50', value: '50' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.51', value: '51' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.52', value: '52' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.53', value: '53' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.54', value: '54' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.55', value: '55' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.56', value: '56' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.57', value: '57' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.58', value: '58' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.59', value: '59' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.60', value: '60' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_FEET.61', value: '61' }
          ]
        }
      },
      { name: 'wtcBoatValue', key: 'WTC_BOAT_VALUE', group: 'OBJECT_INFO',
        inputType: INPUT_TYPES_CONFIG.NUMBER,
        validator: ['', [
          Validators.required
        ]]
      },
      { name: 'wtcBoatpostcode', key: 'OBJECT_ZIP_WTC_BOAT', group: 'INSURANCE_INFO',
        inputType: INPUT_TYPES_CONFIG.TEL,
        validator: ['', [
          Validators.required,
          Validators.pattern('[0-9]{4}$')
        ]],
        customProductTypeConfig: {
          BOAT: {
            key: 'OBJECT_ZIP_BOAT'
          }
        }
      },
    ]
  },
  properties: [
    { name: 'wtcBoatGroup', key: 'WTC_BOAT_GROUP', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_GROUP.SAILBOAT', value: 'Sailboat' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_GROUP.MOTORBOAT', value: 'MotorBoat' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_BOAT_GROUP.NOMOTORBOAT', value: 'NoMotorBoat' }
        ]
      }
    },
  ],
  icon:'boat'
};
